export enum VisibilityPrescriber {
  OPEN = 'OPEN',
  LOCKED = 'LOCKED',
  GMD_HOLDER = 'GMD_HOLDER'
}
